"use strict";
var appn;
(function (appn) {
    var log;
    (function (log_1) {
        let _loggingEnabled = false;
        function init() {
            if (appn.isDebug) {
                _loggingEnabled = true;
                return;
            }
            const enabledFromLs = appn.localStorage.getItem('loggingEnabled');
            _loggingEnabled = enabledFromLs ? true : false;
        }
        log_1.init = init;
        let LogLevel;
        (function (LogLevel) {
            LogLevel[LogLevel["Info"] = 0] = "Info";
            LogLevel[LogLevel["Warning"] = 1] = "Warning";
            LogLevel[LogLevel["Error"] = 2] = "Error";
            LogLevel[LogLevel["Debug"] = 3] = "Debug";
        })(LogLevel || (LogLevel = {}));
        function log(message, logLevel) {
            if (!_loggingEnabled)
                return;
            switch (logLevel) {
                case LogLevel.Info: {
                    console.log(message);
                    break;
                }
                case LogLevel.Warning: {
                    console.warn(message);
                    break;
                }
                case LogLevel.Error: {
                    console.error(message);
                    break;
                }
                case LogLevel.Debug: {
                    console.debug(message);
                    break;
                }
            }
        }
        function info(message, includeCallStack) {
            log(message, LogLevel.Info);
            if (includeCallStack)
                appn.log.debug(new Error().stack);
        }
        log_1.info = info;
        function warning(message, includeCallStack) {
            log(message, LogLevel.Warning);
            if (includeCallStack)
                appn.log.debug(new Error().stack);
        }
        log_1.warning = warning;
        function error(message, includeCallStack) {
            log(message, LogLevel.Error);
            if (includeCallStack)
                appn.log.debug(new Error().stack);
        }
        log_1.error = error;
        function debug(message, includeCallStack) {
            log(message, LogLevel.Debug);
            if (includeCallStack)
                appn.log.debug(new Error().stack);
        }
        log_1.debug = debug;
        class PerfTimer {
            constructor(title) {
                this.time0 = 0;
                this.time1 = 0;
                this.title = appn.emptyString;
                this.title = title;
            }
            start() {
                this.time0 = performance.now();
            }
            stop() {
                this.time1 = performance.now();
                const timeDelta = (this.time1 - this.time0);
                const message = `${this.title}: ${timeDelta.toFixed(5)} ms`;
                appn.log.info(message);
                return message;
            }
        }
        log_1.PerfTimer = PerfTimer;
    })(log = appn.log || (appn.log = {}));
})(appn || (appn = {}));
